import React from 'react';

const PinterestBrand1 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3329_131914)">
      <path
        d="M15.9998 0C7.18743 0 0.0273438 7.16009 0.0273438 15.9725C0.0273438 22.5267 3.93785 28.1446 9.61082 30.6231C9.55572 29.5215 9.61082 28.1446 9.88622 26.9329C10.2167 25.611 11.9241 18.2306 11.9241 18.2306C11.9241 18.2306 11.4284 17.1842 11.4284 15.6971C11.4284 13.3287 12.8053 11.5662 14.5127 11.5662C15.9447 11.5662 16.6607 12.6678 16.6607 13.9896C16.6607 15.4217 15.7244 17.6247 15.2287 19.6626C14.8432 21.37 16.0548 22.7469 17.7623 22.7469C20.7915 22.7469 22.8294 18.8364 22.8294 14.265C22.8294 10.74 20.461 8.15138 16.165 8.15138C11.3182 8.15138 8.28897 11.7865 8.28897 15.8071C8.28897 17.1841 8.67449 18.1755 9.33542 18.9465C9.61082 19.277 9.66591 19.4422 9.55572 19.8277C9.50063 20.1031 9.28032 20.8192 9.22523 21.0945C9.11505 21.48 8.78462 21.6453 8.39909 21.48C6.14093 20.5437 5.14951 18.1203 5.14951 15.3664C5.14951 10.8501 8.94983 5.39744 16.5505 5.39744C22.6641 5.39744 26.6848 9.80366 26.6848 14.5403C26.6848 20.8191 23.2149 25.5007 18.0928 25.5007C16.3853 25.5007 14.733 24.5644 14.1822 23.5179C14.1822 23.5179 13.2459 27.2081 13.0807 27.9242C12.7502 29.1359 12.0893 30.4026 11.4835 31.339C12.9155 31.7796 14.4576 31.9999 15.9998 31.9999C24.8122 31.9999 31.9722 24.8398 31.9722 16.0274C31.9722 7.21506 24.8122 0 15.9998 0Z"
        fill="#CB1F24"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131914">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PinterestBrand1;